export const simplifyForSearch = (value = '') => value.toLowerCase().replace(/[\W_]+/g, '');
